import React from 'react'

function HospitalSystemConfiguration() {
  return (
    <div>System Configuration (fees, charges, tax, billing formats)</div>
  )
}

export default HospitalSystemConfiguration